const formatPathname = (pathname: string): string => {
  // prefix - one of ent-website, campus, business/teams, business or government
  let slug = pathname.replace(
    /^\/(ent-website|(?:business\/teams)|business|partnerships|government|campus|skills-reports|social-impact|enterprise)(\/)?/gi,
    ''
  );

  // Trailing slash
  if (slug[slug.length - 1] === '/') {
    slug = slug.slice(0, -1);
  }

  return slug;
};

export default formatPathname;
